import Axios from 'axios';
import {
  config,
} from '../config';
import md5 from 'blueimp-md5';
// eslint-disable-next-line import/no-cycle

const is = {
  // http错误
  httpError: res => res.status !== 200,
  rpcError: res => res.headers['trpc-error-msg'] || res.headers['trpc-func-ret'],
};

const createResponse = (code, msg = '未知错误', data = null) => ({
  code,
  msg,
  data,
});

const axios = Axios.create({
  timeout: 20000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

axios.interceptors.request.use(
  (data) => {
    // TODO: delete
    // if (process.env.NODE_ENV !== "production") {
    //   data.headers.Authorization = data.url;
    // }
    const timestamp = `${Math.round(new Date().getTime() / 1000)}`;
    const sign = md5(`body=${JSON.stringify(data.data)}&timestamp=${timestamp}`);

    if (!data.url.startsWith('http')) {
      // eslint-disable-next-line no-param-reassign
      data.url = `${config.newApiBaseUrl}/${data.url}?sign=${sign}&timestamp=${timestamp}`;
    }

    return data;
  },
  error => Promise.reject(error),
);

axios.interceptors.response.use(
  (res) => {
    if (is.httpError(res)) {
      return createResponse(res.status, 'HTTP请求错误');
    }

    if (is.rpcError(res)) {
      if (!res.headers['trpc-func-ret']) {
        return createResponse(1, '服务器错误');
      }

      return createResponse(res.headers['trpc-func-ret'] || 1, res.headers['trpc-error-msg'] || '服务器错误');
    }
    res.data.code = 0;
    return res.data;
  },
  err => err,
);

export default axios;
